<template>
  <vue-scroll :ops="ops" ref="vs" @handle-scroll="handleScroll">
    <div class="supCon">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=6 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=6 v-if="!isShowNav"></first-Component>
      <div class="banner animated zoomIn" id="d1">
            <div class="text">
              <span>{{$t('SpTitle')}}</span>
            </div>
            <img   style="width:100%;height:100%;cursor: pointer;display: block"  src="../assets/SUP.png">
            <div class="threeBtn">
              <span :style="select2===0?oneStyle:''"  @click="showCon(0)">{{$t('spList[0]')}}</span>
              <span :style="select2===1?oneStyle:''"  @click="showCon(1)">{{$t('spList[1]')}}</span>
              <span :style="select2===2?oneStyle:''"  @click="showCon(2)">{{$t('spList[2]')}}</span>
            </div>

      </div>
      <div class="rd animated zoomInRight" v-if="select2===0">
        <div class="title">
          <p>{{$t('spList[0]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>

        </div>
        <div class="item" v-for="(item,index) in downList" :key="index" :style="index%2==1?allStyle:''" >
        <span class="a" style="text-transform: capitalize">{{item.TITLE}}</span>
          <span class="b">{{ time(item.NOTETIME) }}</span>
          <span class="c" @click="login" v-if="hasInfo&&index>0">
<i class="iconfont icon-xiazai"></i>
       </span>
          <span class="c" v-if="hasInfo===false || index===0">
            <a :href="`http://www.nbbinyu.com/upload/${item.FILE}`" :download="item.FILE" target="_blank" > <i class="iconfont icon-xiazai"></i></a>
       </span>
        </div>
         <p style="width:1280px;text-align: center;margin: 0 auto;padding-top: 10px;font-family: light;font-size: 20px;text-transform: capitalize">{{$t('Download')}}</p>
      </div>
      <div class="eq animated zoomIn" v-else-if="select2===1">
        <div class="title">
          <p>{{$t('spList[1]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>
        </div>
        <div class="aCon">
          <div class="con">
            <div class="pic">
              <img  src="../assets/waThree.jpg" alt="">
              <img class="th" src="../assets/waOne.jpg" alt="">
            </div>
            <div class="text" style="text-transform: capitalize">
              <p>{{$t('Warr.TITLE1')}}</p>
              <p>
                {{$t('Warr.con1')}}
              </p>
              <p class="a">
                {{$t('Warr.con2')}}
              </p>
            </div>
            <img class="tw" src="../assets/waTwo.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="qu animated fadeInLeft" v-else>
        <div class="title">
          <p>{{$t('spList[2]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>
        </div>
        <div class="allCon">
         <div class="first">
         <div class="item">
           <img src="../assets/wz.png" alt="">
           <p>{{$t('Contact.one[0]')}}</p>
           <p class="a">{{$t('Contact.one[1]')}}</p>
           <p class="a">{{$t('Contact.one[2]')}}</p>
         </div>
           <div class="item">
             <img src="../assets/ph.png" alt="">
             <p>{{$t('Contact.two[0]')}}</p>
             <p class="a">{{$t('Contact.two[1]')}}</p>
             <p class="a">{{$t('Contact.two[2]')}}</p>
           </div>
           <div class="item">
             <img src="../assets/me.png" alt="">
             <p>{{$t('Contact.three[0]')}}</p>
             <p class="a">{{$t('Contact.three[1]')}}</p>
           </div>
         </div>
          <p class="center">{{$t('Contact.TITLE')}}</p>
          <p class="left">{{$t('comTitle')}}</p>
          <div class="form">
            <input type="text" v-model="form2.firstName"  :placeholder="$t('form.first')">
            <input type="text" v-model="form2.lastName" :placeholder="$t('form.last')">
            <input type="text" v-model="form2.job" :placeholder="$t('form.Job')">
            <input type="text" v-model="form2.phone" :placeholder="$t('form.Phone')">
            <input type="text" v-model="form2.email" :placeholder="$t('form.Email')">
            <input type="text" v-model="form2.company"  :placeholder="$t('form.com')">
            <input type="text" v-model="form2.address"  :placeholder="$t('form.add')">
            <br>
            <input type="text" v-model="form2.city" :placeholder="$t('form.city')">
            <input type="text" v-model="form.state" :placeholder="$t('form.state')">
            <input type="text" v-model="form2.province" :placeholder="$t('form.select')">
            <br>
            <input type="text"  :placeholder="$t('form.zip')">
            <input type="text"   :placeholder="$t('form.cou')">
            <input type="text" :placeholder="$t('form.fax')">
          </div>
          <span class="btn">{{$t('send')}}</span>
        </div>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>

      <el-dialog title="User Info" :visible.sync="dialogFormVisible" style="margin-top:5%;">
        <el-form :mode="form">
          <el-form-item label="UserName" >
            <el-input v-model="form.username" autocomplete="off" ></el-input>
          </el-form-item>
          <el-form-item label="PassWord">
            <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
          <el-button type="primary" @click="confirm">Confirm</el-button>
        </div>
      </el-dialog>
    </div>
  </vue-scroll>
</template>

<script>
  import firstComponent from './first'
  import footComponent from './foot'
  import {getNewsUrl} from '../util/lang'
  import qs from 'qs'
    export default {
        name: "support",
      data(){
          return{
            hasInfo:true,
            form2:{},
            form:{
              username:'',
              password:''
            },
            dialogFormVisible:false,
            allStyle:{
              backgroundColor:'#FAFAFA'
            },
            isShowNav:true,
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 300,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
            select2:0,
            downList:[
              // {content:"What you need to download",date:'2019-6-24'},
              // {content:"What you need to download",date:'2019-6-23'},
              // {content:"What you need to download",date:'2019-6-22'},
              // {content:"What you need to download",date:'2019-6-21'},
              // {content:"What you need to download",date:'2019-6-20'},
              // {content:"What you need to download",date:'2019-6-19'}
            ],
            oneStyle:{
              backgroundColor:' #0C3665',
              color:'white'
            }
          }
      },
      components:{firstComponent,footComponent},
      mounted(){
        if(this.$route.query.select!=undefined){
          this.select=this.$route.query.select
          this.select2=this.$route.query.select
        }else{
          console.log("路由跳转参数为空")
        }
        this.$nextTick(()=>{
          if(this.$i18n.locale==='en'){
            this.getPro('9')
          }else{
            this.getPro('11')
          }
        })
      },
      methods:{
          time(n){
            return n.slice(0,10)
          },
        gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
          login(){
              this.form={
                username:'',
                password:''
              }
              this.dialogFormVisible=true

          },
        getPro(id){
          this.$nextTick(()=>{
            const url = `${getNewsUrl( this.$i18n.locale,id,100,1)}`
            this.$axios.get(url).then(res => {
              this.downList=res.data.newsArr
            })
          })
        },
          confirm(){
            if(this.form.username==='' || this.form.password===''){
              this.$notify({
                title: 'Sorry',
                message: 'Please enter the complete information',
                offset: 100
              });
            }else {
              const url ='/php/login.php'
              this.$axios.post(
                url,
                qs.stringify(
                  this.form
                )
              ).then(res => {
                if(res.data.code===1){
                  this.$notify({
                    title: 'Login Successful',
                    message: 'Coming soon, please be patient',
                    offset: 100
                  });
                  this.dialogFormVisible=false
                  this.hasInfo=false
                }else{
                  this.$notify({
                    title: 'Sorry',
                    message: 'This account does not exist',
                    offset: 100
                  });
                }
              })
            }
          },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
        },
        showCon(n){
          this.select2=n
        },
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.supCon{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    .text{
      position: absolute;
      top:60%;
      left: 11%;
      color:white;
      span{
        font-size: 35px;
        font-weight: bold;
        display: inline-block;
        padding-bottom: 10px;
        position: relative;
        border-bottom: 1px solid rgba(255,255,255,.3);
      }
    }
    .threeBtn{
      width:100%;
      color:white;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      span{
        display: inline-block;
        width:20%;
        color:#0C3665;
        padding:15px 10px;
        text-align: center;
        margin-left: 0.1%;
        font-weight: bold;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color:rgba(255,255,255,0.9);
      }
      span:hover{
        background-size: 100% 100%;
        color:white;
      }
    }
  }
  .rd{
    width:100%;
    padding-bottom: 60px;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .item{
      width:1280px;
      margin: 0 auto;
      border: 1px solid #FAFAFA;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
      background-size: 100% 0%;
      text-transform: uppercase;
      -webkit-transition: all .5s;
      transition: all .5s;
      background-color: #ECECEC;
      span{
        display: inline-block;
        height:60px;
        line-height: 60px;
        font-family: light;
        font-size: 14px;
      }
      .a{
        width:70%;
        text-indent: 5%;
      }
      .b{
        width:15%;
        padding-left: 5%;
      }
      .c{
        width:5%;
        padding-left: 5%;
        padding-top: 5px;
        height:50px;
      }
    }
    .item:hover{
      background-size: 100% 100%;
      color:white;
    }
    .item:hover .c a i{
      color:white;
    }
  }
  .eq{
    width:100%;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .aCon{
      width:100%;
      background-color: #F3F3F3;
      padding-top: 120px;
      padding-bottom: 120px;
      .con{
        width:1280px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        position: relative;
        .pic{
          img{
            margin-top: 50px;
          }
        }
        .text{
          width:80%;
          p{

            font-size: 18px;
          }
          p:first-child{
            font-size: 30px;
            color:#0C3665;
          }
          p:not(:first-child){
            font-family: light;
            line-height: 40px;
          }
          .a{
            margin-top: 60px;
          }
        }
        .tw{
          position: absolute;
          left: 8%;
          top:35%;
        }
        img{
          transition: all 1s;
          cursor: pointer;
        }
        img:hover{
          transform: scale(1.1); /* 放大1.2倍 */
        }
      }
    }
  }
  .qu{
    width:100%;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .allCon{
      width:1280px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      padding-top: 20px;
      .first{
        width:100%;
        display: flex;
        flex-direction: row;
        .item{
          width:32%;
          margin-left: 1%;
          text-align: center;
          p:first-child{
            color:#0C3665;
          }
          .a{
            font-family: light;
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
      .center{
        text-align: center;
        font-family: light;
        margin-top: 40px;
      }
      .left{
        text-align: left;
        font-size: 25px;
        color:#0C3665;
        padding-left: 1%;
      }
      .form{
        width:100%;
        padding-left: 1%;
        margin-top: 30px;
        input{
          width:30%;
          height:35px;
          font-family: light;
          margin-top: 20px;
          text-indent: 2%;
        }
        input{
          border: 1px solid rgba(0,0,0,.1);
        }
        input:focus{
          outline: none;
        }
        .short{
          width:15%;
        }
      }
      .btn{
        margin: 50px auto;
        display: inline-block;
        color:#C7000C;
        padding: 8px 3%;
        font-size: 12px;
        border: 1px solid #0C3665;
        -webkit-border-radius: 60px / 50px;
        -moz-border-radius: 60px / 50px;
        border-radius: 60px / 60px;
        cursor: pointer;
        font-weight: bold;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
      }
      .btn:hover{
        background-size: 100% 100%;
        color: white;
      }
    }
  }
  @media screen and (max-width:768px){
    .banner{
      img{
        height:500px !important;
        object-fit: cover;
      }
    }
    .rd{
      .item{
        width:100%;
        .b{
          width:25%;
        }
      }
      p{
        width:100% !important;
        text-align: center !important;
      }
    }
    .eq{
      .aCon{
        .con{
          width:100%;
        }
      }
    }
    .qu{
      .allCon{
        width:100%;
      }
    }
  }
  @media screen and (max-width:450px){
    .banner{
      .threeBtn{
        flex-direction: column;
        position: static;
        padding-bottom: 30px;
        span{
          width:100%;
          font-size: 10px;
          padding: 10px 5px;
          margin-top: 10px;
          background-color:#FAFAFA;
        }
      }
      .text{
        top:50%;
      }
    }
    .rd{
      padding-bottom: 0;
      .item{
        .a{
          width:80%;
          overflow: hidden;
        }
        .c{
          padding-right: 5%;
        }
        span{
          font-size: 12px;
        }
      }
      p{
        font-size: 15px !important;
      }
    }
    .eq{
      .aCon{
        .con{
          flex-direction: column;
          .pic{
            padding-left: 5%;
           .th{
             margin-top: 50px;
           }
          }
          .tw{
            top:10%;
           left:18%;
          }
          .text{
            padding-left: 2%;
            width:90%;
            text-align: center;
            p:first-child{
              font-size: 18px;
            }
            p:not(first-child){
              font-size: 14px;
            }
          }
        }
      }
    }
    .qu{
      .allCon{
        .first{
          flex-direction: column;
          .item{
            width:100%;
          }
        }
        .left{
          text-align: center;
        }
        .btn{
          padding: 6px 8%;
        }
        .center{
          width:90%;
          margin-left: 5%;
          font-size: 14px;
        }
        .form{
          input{
            width:90%;
            margin-left: 5%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/support.vue